import React from 'react';
import PropTypes from 'prop-types';

import { ListItem, Typography } from '@sm/wds-react';

export const SubMenuItem = ({
  title,
  name,
  path,
  url,
  openInNewWindow,
  show,
}) => {
  const itemTitle = name || title;
  const itemURL = path || url;

  if (!itemTitle || !itemURL || !show) return null;

  return (
    <ListItem
      key={itemTitle}
      isNavigable
      navigationTarget={itemURL}
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      <Typography
        variant="sectionTitle"
        color="link"
        className="sm-mobile-menu-anon__type-title"
      >
        {itemTitle}
      </Typography>
    </ListItem>
  );
};

SubMenuItem.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string,
  url: PropTypes.string,
  openInNewWindow: PropTypes.bool,
  show: PropTypes.bool,
};

SubMenuItem.defaultProps = {
  title: undefined,
  name: undefined,
  path: undefined,
  url: undefined,
  openInNewWindow: false,
  show: true,
};

export default SubMenuItem;
